var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('server-data',{attrs:{"method":function (params) { return _vm.$api.courses.index(params, _vm.serviceType); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var serverData = ref.serverData;
var loading = ref.loading;
return [_c('select-list-course',_vm._g({attrs:{"items":serverData,"loading":loading}},_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }